import { EntityBase } from './EntityBase';
import { Author } from './Author';
import { UserChangeReport } from './UserChangeReport';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class UserChangeReportAuthor extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   userChangeReportAuthorId: number;
   userChangeReportId: number;
   authorId: number;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   author: Author;
   userChangeReport: UserChangeReport;
}

